import {Mental2SymbolStates} from "../enums/Enum";
import {Symbol} from "./Symbol";
import TrackEntry = PIXI.spine.core.TrackEntry;

export class SplitSymbol extends Symbol {


    constructor(symbolName: string, initState: Mental2SymbolStates, index: number, isActive: boolean = false) {
        super(symbolName, initState, index);
    }

    public playEnhancerReveal(): void {
        this._currentHeight = 99;
        this.state.addAnimation(0, "99", false, 0);
    }

    public setResizeState(animName: string): TrackEntry {
        return super.setResizeState(animName);
    }
}